import React, { useEffect, useState } from "react";
import PetAvatar from "assets/images/pet-avatar.svg";
import PetRow from "./PetRow";
import PetsMobileTable from "./PetsMobileTable";
import { useDispatch, useSelector } from "react-redux";
import { pet, successMessage } from "redux-store/pets/pet.selector";
import { useNavigate } from "react-router-dom";
import { getUserPets, messageClean } from "redux-store/pets/pet.slice";
import { AppDispatch } from "redux-store/store";
import { user } from "redux-store/user/user.selectors";
import { getLoggedInUser } from "redux-store/user/user.slice";

const PetsTable = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1060);
  const pets = useSelector(pet);
  const logedInUser = useSelector(user);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getLoggedInUser());
  }, []);

  useEffect(() => {
    if (logedInUser?._id) {
      dispatch(getUserPets(logedInUser?._id));
    }
  }, [logedInUser]);

  const handleResize = () => {
    setIsMobile(window.innerWidth < 990);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isMobile]);
  return (
    <>
      {isMobile ? (
        <>
          {pets?.length !== 0 && pets ? (
            pets?.map((pet, i) => (
              <PetsMobileTable
                key={i}
                petName={pet?.petName}
                gender={pet?.petGender}
                breed={pet?.petBreed}
                _id={pet?._id}
              />
            ))
          ) : (
            <>
              <span className=" tw-ml-12 tw-text-md">No Pet Found</span>
            </>
          )}
        </>
      ) : (
        <div className="tw-w-[90%] tw-mx-auto tw-bg-[#FFFFFF] tw-shadow-3xl tw-rounded-xl  tw-py-7">
          <div className="tw-w-[90%] tw-mx-auto tw-flex tw-flex-col ">
            {/* Attributes Col */}
            <div className="tw-flex tw-mb-5">
              {/* empty div */}
              <div className="tw-w-[5%]">
                <span className="tw-hidden">Image here</span>
              </div>
              {/* attributes names */}
              <div className="tw-w-[95%] tw-flex tw-items-center tw-justify-between">
                <div className="tw-flex-1 ">
                  <p className="tw-text-xl tw-text-[#29223E] tw-font-bold">Pet Name</p>
                </div>
                <div className="tw-flex-1">
                  <p className="tw-text-xl tw-text-[#29223E] tw-font-bold">Gender</p>
                </div>
                <div className="tw-flex-[1.5_1.5_0%]">
                  <p className="tw-text-xl tw-text-[#29223E] tw-font-bold">Pet Breed</p>
                </div>
                <div className="tw-flex-1">
                  <span className="tw-hidden tw-text-xl tw-text-[#29223E] tw-font-bold">Something</span>
                </div>
              </div>
            </div>
            {/* Data Col */}
            {pets?.length !== 0 && pets ? (
              pets?.map((pet, i) => (
                <PetRow
                  key={i}
                  name={pet?.petName}
                  avatar={pet?.photo}
                  gender={pet?.petGender}
                  breed={pet?.petBreed}
                  _id={pet?._id}
                />
              ))
            ) : (
              <>
                <span className=" tw-ml-12 tw-text-md">No Pet Found</span>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default PetsTable;
